import React from 'react';
import OptionButton from '../shared/OptionButton';
import { getTrainingPurposeOptions } from '../onboardingQuestions';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const TrainingPurposeStep: React.FC<StepProps> = ({ answer, onAnswer, answers }) => {
  const options = getTrainingPurposeOptions(answers.experience_level ?? null);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {options.map((opt) => (
        <OptionButton
          key={opt.value}
          label={opt.label}
          value={opt.value}
          selected={answer === opt.value}
          onClick={onAnswer}
        />
      ))}
    </div>
  );
};

export default TrainingPurposeStep;
